import { render, staticRenderFns } from "./MonthlySalesReport.vue?vue&type=template&id=006c5502&scoped=true&"
import script from "./MonthlySalesReport.vue?vue&type=script&lang=js&"
export * from "./MonthlySalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c5502",
  null
  
)

export default component.exports